export const WIDGET = 'widget';
export const REVIEW = 'review';
export const DATE = 'date';
export const TIME = 'time';
export const INFO = 'info';
export const DROPDOWN = 'dropdown';
export const RADIO = 'radio';
export const CHECKBOX = 'checkbox';
export const OBJECT = 'object';
